import React, { useEffect, useRef, useState } from 'react';
import { Animated, Easing, StyleSheet, TextInput, View, } from 'react-native';
import { Typography } from "../typography/Typography";
import { ColorTokens, TypographyTypeDLS } from "@voltmoney/schema";
import ThemeProvider from "@voltmoney/theme";
import { TextInputStateDLS } from "@voltmoney/schema/lib/textInputDLS";
import { isFromTDLPlatform } from '../pages/utils';
const theme = ThemeProvider.getTheme();
const fontFamilyMapping = theme.fontFamily;
const TextFieldDLS = (props) => {
    const { label, errorText, value, style, onBlur, onFocus, showError, helperText, inputState = TextInputStateDLS.DEFAULT, isDisable, onChangeText, isFromCgs, ...restOfProps } = props;
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [isFocused, setIsFocused] = useState(false);
    const [_inputState, setInputState] = useState(inputState);
    const [_helperText, setHelperText] = useState(helperText);
    const inputRef = useRef(null);
    const focusAnim = useRef(new Animated.Value(0)).current;
    const isfromTDL = isFromTDLPlatform();
    useEffect(() => {
        if (value && value !== "") {
            setIsFocused(true);
        }
        else {
            setIsFocused(false);
        }
    }, [value]);
    useEffect(() => {
        Animated.timing(focusAnim, {
            toValue: isFocused || !!value ? 1 : 0,
            duration: 150,
            easing: Easing.bezier(0.4, 0, 0.2, 1),
            useNativeDriver: true,
        }).start();
    }, [focusAnim, isFocused, value]);
    useEffect(() => {
        if (!isFocused &&
            inputState === TextInputStateDLS.ERROR) {
            setInputState(TextInputStateDLS.ERROR);
        }
        else {
            if (isFromCgs) {
                setInputState(TextInputStateDLS.DEFAULT);
            }
            else {
                setInputState(inputState);
            }
        }
    }, [
        inputState,
        isFocused
    ]);
    const renderHelperText = () => {
        return (_helperText &&
            _inputState !== TextInputStateDLS.DEFAULT &&
            React.createElement(React.Fragment, null,
                React.createElement(View, { style: styles.helperText },
                    React.createElement(Typography, { label: _helperText, typeDLS: TypographyTypeDLS.B2R, color: _inputState === TextInputStateDLS.ERROR ?
                            ColorTokens.System_Error :
                            _inputState === TextInputStateDLS.SUCCESS ?
                                ColorTokens.System_Happy :
                                ColorTokens.Grey_Charcoal }))));
    };
    const getInputBorderColor = () => {
        if (isDisable) {
            return colorMapping[ColorTokens.Grey_Smoke];
        }
        else if (_inputState === TextInputStateDLS.SUCCESS) {
            return colorMapping[ColorTokens.System_Happy];
        }
        else if (_inputState === TextInputStateDLS.ERROR) {
            return colorMapping[ColorTokens.System_Error];
        }
        else if (isFocused) {
            return colorMapping[ColorTokens.Primary_100];
        }
        else {
            return colorMapping[ColorTokens.Grey_Smoke];
        }
    };
    return (React.createElement(View, { style: style },
        React.createElement(TextInput, { style: [
                styles.input,
                {
                    color: isDisable ? colorMapping[ColorTokens.Grey_Smoke] : colorMapping[ColorTokens.Grey_Night],
                    borderColor: getInputBorderColor(),
                    zIndex: isFocused ? 0 : 1,
                    borderRadius: isfromTDL ? 8 : 4
                },
                //@ts-ignore
                { outlineStyle: 'none' }
            ], editable: !isDisable, ref: inputRef, value: value, onChange: () => {
                !isDisable &&
                    setInputState(TextInputStateDLS.DEFAULT);
            }, onChangeText: (value) => {
                !isDisable &&
                    onChangeText(value);
            }, onBlur: (event) => {
                setIsFocused(false);
                onBlur?.(event);
            }, onFocus: (event) => {
                setIsFocused(true);
                onFocus?.(event);
            }, ...restOfProps }),
        React.createElement(Animated.View, { style: [
                styles.labelContainer,
                {
                    zIndex: value ? 1 : 0
                },
                {
                    transform: [
                        {
                            scale: focusAnim.interpolate({
                                inputRange: [0, 1],
                                outputRange: [1, 0.75],
                            }),
                        },
                        {
                            translateY: focusAnim.interpolate({
                                inputRange: [0, 1],
                                outputRange: [13, -13],
                            }),
                        },
                        {
                            translateX: focusAnim.interpolate({
                                inputRange: [0, 1],
                                outputRange: [16, 0],
                            }),
                        },
                    ],
                },
            ] },
            React.createElement(Typography, { label: isFocused || value !== "" ? label : props.holder, typeDLS: (!isFocused && value === '') ? TypographyTypeDLS.B0R : TypographyTypeDLS.B1R, color: _inputState === TextInputStateDLS.ERROR
                    ? ColorTokens.System_Error
                    : ColorTokens.Grey_Smoke })),
        renderHelperText()));
};
const styles = StyleSheet.create({
    input: {
        height: 48,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderWidth: 1,
        fontFamily: fontFamilyMapping.Inter,
    },
    labelContainer: {
        position: 'absolute',
        paddingHorizontal: 4,
        backgroundColor: 'white',
    },
    label: {
        fontFamily: 'Inter',
        fontSize: 14,
    },
    error: {
        marginTop: 4,
        marginLeft: 12,
        fontSize: 12,
        color: '#F04438',
        fontFamily: 'Avenir-Medium',
    },
    helperText: {
        marginTop: 4,
    }
});
export default TextFieldDLS;
